export const fragenHome = [
  {
    question: "Kann ich mein finanziertes Auto verkaufen?",
    answer: (
      <>
        <p>
          Ja, du kannst dein finanziertes Auto über Autoeinfachlos verkaufen.
        </p>
        <p>
          Wenn du bereit bist, dein finanziertes Auto zu verkaufen, ist der
          erste Schritt, den „Ablösebetrag“ von deiner Bank zu erhalten und eine
          Fahrzeugbewertung durchzuführen. Lies mehr in unserem Leitfaden zum
          Verkauf deines finanzierten Autos in Österreich.
        </p>
      </>
    ),
  },
  {
    question: "Ist es kostenlos, mein Auto mit Autoeinfachlos zu verkaufen?",
    answer: (
      <>
        <p>
          Ja, die Bewertung deines Autos ist immer kostenlos und unverbindlich,
          und beim Verkauf über uns fallen keinerlei Verwaltungs-, Zahlungs-
          oder Abholgebühren oder versteckte Kosten an. Über 5.000 Händler
          bieten auf dein Fahrzeug, und du erhältst automatisch das beste
          Preisangebot. Wenn dein Auto wie beschrieben profiliert ist, bekommst
          du den gesamten Betrag ohne weiteres ausgezahlt.
        </p>
        <p>
          Wir erheben eine Provision von dem Händler, der dein Auto kauft, damit
          Autoeinfachlos für unsere Kunden komplett kostenlos bleibt. Erfahre
          hier, wie es funktioniert.
        </p>
      </>
    ),
  },
  {
    question: "Wie kann ich mein Auto schnell verkaufen?",
    answer: (
      <>
        <p>
          Mit Autoeinfachlos ist es ganz einfach, dein Auto schnell zu
          verkaufen. Du kannst dein Fahrzeug in wenigen Schritten bewerten
          lassen und zum Verkauf bereitstellen. Noch am selben Tag erhältst du
          das beste Angebot von über 5.000 Händlern, und dein Auto kann in nur
          24 Stunden verkauft sein.
        </p>
        <p>
          Eine schnelle, kostenlose Abholung und zügige Bezahlung sorgen dafür,
          dass das Geld schnell auf deinem Konto ist. Mit Autoeinfachlos musst
          du keine Kompromisse zwischen Schnelligkeit und Bequemlichkeit
          eingehen. Verkauf noch heute schnell und unkompliziert!
        </p>
      </>
    ),
  },
  {
    question: "Wie viel ist mein Auto wert?",
    answer: (
      <>
        <p>
          Da wir die Fahrzeuge nicht selbst ankaufen, liegt unser Fokus
          ausschließlich darauf, den tatsächlichen Marktwert deines Autos zu
          ermitteln – ohne manipulierte Ankaufspreise.
        </p>
        <p>
          Die smarte Bewertungstechnologie von Autoeinfachlos nutzt aktuelle
          Daten aus dem österreichischen Automarkt und liefert dir eine
          objektive Fahrzeugbewertung. Du erhältst von uns eine transparente
          Einschätzung des Durchschnittspreises und siehst, wie viele Fahrzeuge
          zu diesem Preis verkauft werden. Dabei berücksichtigen wir relevante
          Faktoren wie Baujahr, Kilometerstand , Zustand deines Fahrzeugs und
          vieles mehr.
        </p>

        <p>
          Nach der Bewertung kannst du in deinem Profil Benachrichtigungen
          anpassen und monatliche Updates erhalten, um dein Auto zum
          bestmöglichen Zeitpunkt zu verkaufen.
        </p>
      </>
    ),
  },
  {
    question: "Wer kauft mein Auto?",
    answer: (
      <>
        <p>
          Bei Autoeinfachlos bieten rund 5.000 Händler um den besten Preis für
          dein Auto. Sobald die tägliche Online-Auktion endet, erhältst du
          automatisch das höchste Angebot und kannst dein Auto an den
          Höchstbietenden verkaufen.
        </p>
        <p>
          Stell dir vor, du fährst zu jedem Autohändler in Österreich, um das
          beste Angebot einzuholen, und verkaufst am Ende an den Höchstbietenden
          – genau das bieten wir dir mit nur einem Klick, bequem von zu Hause
          und innerhalb von 24 Stunden.
        </p>
      </>
    ),
  },
  {
    question: "Wo kann ich mein Auto zum Bestpreis verkaufen?",
    answer: (
      <>
        <p>
          Bei Autoeinfachlos stellen wir sicher, dass du das beste Angebot von
          geprüften Autohändlern erhältst – ohne Gebühren oder Provisionen.
        </p>
        <p>
          Sieh dir unseren Leitfaden an, um weitere Tipps zu bekommen, wie du
          beim Verkauf den höchsten Preis für dein Auto erzielen kannst.
        </p>
      </>
    ),
  },
  {
    question:
      "Ist es besser, mein Auto in Zahlung zu geben oder online zu verkaufen?",
    answer: (
      <>
        <p>
          Bei Autoeinfachlos greifst du auf ein Netzwerk von über 5.000
          geprüften Händlern zu, die darum konkurrieren, dir den besten Preis zu
          bieten. Durch die tägliche Online-Auktion erhältst du so das
          höchstmögliche Angebot von einem österreichweiten Netzwerk.
        </p>

        <p>
          Der Bestpreis, den du hier erzielst, kann oft höher ausfallen als bei
          der klassischen Inzahlungnahme, bei der du auf die Bewertung eines
          einzigen Händlers beschränkt bist – was oft nicht den tatsächlichen
          Marktwert deines Autos widerspiegelt.
        </p>
      </>
    ),
  },
  {
    question:
      "Kann ich jede Automarke und jedes Modell über Autoeinfachlos verkaufen?",
    answer: (
      <>
        <p>
          Mit Autoeinfachlos findest du einen Käufer für dein Auto – unabhängig
          von Marke oder Modell.
        </p>
        <p>
          Wir helfen dir, dein Gebrauchtwagen kostenlos zu verkaufen,
          einschließlich beliebter Marken wie Ford, Volkswagen, BMW, Audi,
          Toyota, Nissan, Tesla und viele weitere.
        </p>

        <p>
          Autoeinfachlos bietet einen fairen und transparenten Marktplatz für
          Gebrauchtfahrzeuge, der für jeden Vorteile bringt – egal, ob du ein
          Benzin-, Diesel-, Hybrid- oder Elektrofahrzeug, einen Van oder einen
          SUV verkaufst.
        </p>
      </>
    ),
  },
];
